import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, updateDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase'

const { db } = initFirebase()

const generateZodiacSlidesFn = httpsCallable(functions, 'generateZodiacSlides')

export class FirebaseSocialHooksService {
  async getAllSocialHooks() {
    const ref = collection(db, 'social_hooks')
    const q = query(ref, orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async updateStatus(id, status) {
    const ref = doc(db, 'social_hooks', id)
    await updateDoc(ref, { status })
  }

  async getSlides(hookId) {
    if (!hookId) return []
    const ref = collection(db, 'social_hooks', hookId, 'slides')
    const q = query(ref, orderBy('signOrder', 'asc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async generateZodiacSlides(hookId) {
    const result = await generateZodiacSlidesFn({ hookId })
    return result.data
  }

  async generateZodiacSlidesAdHoc(hookText) {
    const result = await generateZodiacSlidesFn({ hookText })
    return result.data
  }
}
